import axios from 'axios';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Formik } from 'formik';
import { errorHandler } from 'helpers/response-utils';
import { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RewardDrinkEditValidationSchema } from 'static/validations/rewardDrinkValidationSchema';
import * as yup from 'yup';

const RewardDrinkEdit = () => {
  const nav = useNavigate();
  const token = localStorage.getItem('token');
  const schema = yup.object().shape(RewardDrinkEditValidationSchema);
  const [initialValues, setInitialValues] = useState({
    name: '',
    rewardIdentity: '',
    points: '',
    waterAmount: ''
  });
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/reward-drink/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      errorHandler(response);
      if (response.data['status'] == 'error') {
        toast.error(response.data['message']);
        return false;
      }
      setInitialValues(response.data['data']['rewardRule']);
    };

    fetchData();
  }, [id]);

  const onSubmit = async (values: any) => {
    const response = await axios.put(
      `${process.env.REACT_APP_ENDPOINT}/reward-drink/${id}`,
      values,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    toast.success(response.data['message']);
    nav('/reward-rules/drink');
  };

  const navigateBack = () => {
    nav(-1);
  };
  return (
    <Card className="col-xl-8 col-lg-6 col-md-12 col-sm-12">
      <Card.Header>
        <div className="d-sm-flex justify-content-between">
          <h2>Edit</h2>
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xl={12}>
            <Formik
              validationSchema={schema}
              onSubmit={values => onSubmit(values)}
              initialValues={initialValues}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                setValues
              }) => {
                useEffect(() => {
                  setValues(initialValues);
                }, [initialValues]);
                return (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className={classNames('g-3', 'mb-6')}>
                      <Col sm={6} md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isValid={touched.name && !errors.name}
                            isInvalid={touched.name && !!errors.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {' '}
                            {errors.name}{' '}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col sm={6} md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Reward Identity</Form.Label>
                          <Form.Control
                            type="text"
                            name="rewardIdentity"
                            value={values.rewardIdentity}
                            onChange={handleChange}
                            isValid={
                              touched.rewardIdentity && !errors.rewardIdentity
                            }
                            isInvalid={
                              touched.rewardIdentity && !!errors.rewardIdentity
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {' '}
                            {errors.rewardIdentity}{' '}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col sm={6} md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Points</Form.Label>
                          <Form.Control
                            type="text"
                            name="points"
                            value={values.points}
                            onChange={handleChange}
                            isValid={touched.points && !errors.points}
                            isInvalid={touched.points && !!errors.points}
                          />
                          <Form.Control.Feedback type="invalid">
                            {' '}
                            {errors.points}{' '}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col sm={6} md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Water Amount</Form.Label>
                          <Form.Control
                            type="text"
                            name="waterAmount"
                            value={values.waterAmount}
                            onChange={handleChange}
                            isValid={touched.waterAmount && !errors.waterAmount}
                            isInvalid={
                              touched.waterAmount && !!errors.waterAmount
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {' '}
                            {errors.waterAmount}{' '}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <div className="text-end">
                        <Button
                          variant="phoenix-primary"
                          className="me-2 px-6"
                          onClick={navigateBack}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                          Create
                        </Button>
                      </div>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default RewardDrinkEdit;
